import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-profile-featured',
  templateUrl: './user-profile-featured.component.html',
  styleUrls: ['./user-profile-featured.component.css']
})
export class UserProfileFeaturedComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
